import React, { useEffect, useState } from "react";
import { appServerSideProps } from "../../utils/getAppService";
import Accordion from "../../components/accordion/Accordion";
import { authGetRequest } from "../../utils/authGetRequest";
import Day7 from "../../assets/images/sevendays.png";
import OneMonth from "../../assets/images/onemonth.png";
import OneYear from "../../assets/images/oneyear.png";
import GreenTick from "../../assets/images/green-tick.png";
import DiscordLogo from "../../assets/images/discord_logo.png";
import Image from "next/image";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import Link from "next/link";
import MainLayout from "../../components/MainLayout/MainLayout";
import LineValueStats from "../../components/linevalue/linevalue-stats";
import Testimony from "../../components/home/Testimony";
import WelcomeScoreCards from "../../components/WelcomeScoreCards";
import blankCalendar from "../../assets/images/blankCalendar.png";
import nbaLiveBanner from "../../assets/images/NBA_live_banner.gif";
import Utils from "../../utils/Utils";
import { BiSolidCheckboxChecked } from "react-icons/bi";
dayjs.extend(advancedFormat);

export const accordionData = [
  {
    "@type": "Question",
    name: "How are ShotQuality’s NCAAB bets determined?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "ShotQuality uses Vegas odds to calculate and identify the high-probability games with the most points of value. Vegas sets lines according to actual results, the ShotQuality Betting Model makes projections based on expected scores, which eliminates variability and increases predictive accuracy.",
    },
    id: "accordionData1",
  },
  {
    "@type": "Question",
    name: "Does ShotQuality Bets offer free NCAAB picks?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Yes, ShotQuality Bets offers free college basketball picks on Twitter throughout the season. Play recommendations will also be discussed on the ShotQuality Bets Podcast on Mondays and Thursdays. Make sure to sign up to receive alerts for everything ShotQuality and exclusive free trial offers!",
    },
    id: "accordionData2",
  },
  {
    "@type": "Question",
    name: "What makes ShotQuality the best NCAA Basketball predictions?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Vegas odds for men's basketball can be misleading. They are determined by a herd mentality, but often don’t factor nuanced data into calculations on a large scale. The ShotQuality Bets model analyzes nearly every aspect of in-game play to more deeply understand each team’s competitive advantage and how it would stack up again a respective opponent.",
    },
    id: "accordionData3",
  },
  {
    "@type": "Question",
    name: "Does ShotQuality provide NCAA expert picks?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "ShotQuality is the expert. With a 53.5% win percentage, our algorithm is one of the most, if not the most, expert NCAA handicappers in the industry. We follow math, not feelings. We encourage NCAA basketball experts to compare their analysis with the our algorithm’s findings.",
    },
    id: "accordionData4",
  },
  {
    "@type": "Question",
    name: "What are the best NCAA Basketball picks today?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "NCAA basketball lines change every day; as teams, schedules and match-ups are constantly evolving. It’s impossible for one person to keep track of every line, let alone uncover the best opportunities among them. The ShotQuality Bets Value Finder makes is seamless to track all NCAAB lines and find the best opportunities.",
    },
    id: "accordionData5",
  },
  {
    "@type": "Question",
    name: "Are ShotQuality Bets lines generated by a computer?",
    acceptedAnswer: {
      "@type": "Answer",
      text: "Yes, ShotQuality Bets' computer algorithms recommend the best lines using a points-of-value system. No emotion, no human error, just algorithmically proven projections to help you make smarter plays.",
    },
    id: "accordionData6",
  },
];

const Pricing = ({ user }) => {
  const [authToken, setAuthToken] = useState(null);
  useEffect(() => {
    if (user) {
      setAuthToken(document.cookie.split("token_access=").pop().split(";").shift());
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      authGetRequest(`/api/visited/pricing`, authToken)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => console.error(err));
    }
  }, [user, authToken]);

  return (
    <>
      <MainLayout showLiveLinkHeader={false}>
        <div className="bg-white">
          <div className="container">
            <div className="pt-5 text-center ">
              {/* <h6>
                <span className="blink" style={{ color: "orange" }}>
                  👋 DEAL
                </span>{" "}
                :<Link href={"/welcome-nba"}> Get NBA ALL ACCESS through the Finals for $499.99 </Link>
              </h6> */}
              {/* <h6>
                <span className="blink" style={{ color: "orange" }}>
                  NEW
                </span>
                :
                <Link href={"/welcome-wnba"}>
                  {" "}
                  Get premium access for all WNBA Full Season games for <s style={{ fontWeight: "400" }}>
                    $299.99
                  </s>{" "}
                  $199.99
                </Link>
              </h6> */}
            </div>
            <div className="pt-3 text-center row">
              <div className="col-md-6 col-12 offset-md-3">
                <h2>Choose your plan to unlock access to the best data in basketball</h2>
              </div>
            </div>
            <div className="row mt-4 mb-4">
              <div className="col-12 col-md-4 offset-md-2 mb-4">
                <div className="b-radius-4 d-flex align-items-center justify-content-center flex-column gap-4 border border-black pt-4 pb-4">
                  <h3>Standard Plan</h3>
                  <Link
                    href="/register/standard-weekly-25"
                    className="package-card d-flex justify-content-center align-items-center flex-column"
                  >
                    <span className="calendar-text-wrapper">
                      <Image src={blankCalendar.src} width="150" height="120" alt="seven days" />
                      <span className="text pl-2 pr-2 fw-9"> 1 WEEK </span>
                    </span>
                    <strong className="mt-3 cursor-pointer btn btn-dark">$19.99 EVERY WEEK</strong>
                  </Link>
                  <Link
                    href="/register/standard-monthly-25"
                    className="package-card d-flex justify-content-center align-items-center flex-column"
                  >
                    <span className="calendar-text-wrapper">
                      <Image src={blankCalendar.src} width="150" height="120" alt="seven days" />
                      <span className="text pl-2 pr-2 fw-9"> 1 MONTH </span>
                    </span>
                    <strong className="mt-3 cursor-pointer btn btn-dark">$49.99 EVERY MONTH</strong>
                  </Link>
                  <Link
                    href="/register/standard-annual-25"
                    className="package-card d-flex justify-content-center align-items-center flex-column"
                  >
                    <span className="calendar-text-wrapper">
                      <Image src={blankCalendar.src} width="150" height="120" alt="seven days" />
                      <span className="text pl-2 pr-2"> 1 YEAR </span>
                    </span>
                    <strong className="mt-3 cursor-pointer btn btn-dark">$299.99 Every Year</strong>
                    <div className="text-orange">Save 50%</div>
                  </Link>
                  <div className="text-left p-2 w-100">
                    <h4 className="text-center">What do I get?</h4>

                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> NBA Live Scorecenter </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> NBA Player Prop Data </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> NBA Betting Writeups </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> ShotQuality Standings </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> ShotQuality NBA Trends </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> Daily Predicted ShotQuality Scores </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> Matchup Simulator </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> Individual Player Data </span>
                    </p>
                    <p className="text-black">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#696767" }} />
                      <span>Select NCAA Live Games</span>{" "}
                    </p>
                    <p className="text-black">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#696767" }} />
                      <span>ShotQuality Game Results Past 7 Days</span>{" "}
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center" style={{ maxWidth: "20rem" }}>
                      <BiSolidCheckboxChecked
                        fill="#719a3a"
                        style={{ fontSize: "2rem", color: "#719a3a", minWidth: "2rem" }}
                      />
                      <a
                        href="https://discord.com/invite/shotquality"
                        className="text-black is-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image src={DiscordLogo.src} height={15} width={20} alt="green tick" /> Members have early
                        access to Live Picks and Members only content in Discord. ⏰
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-4">
                <div className="b-radius-4 d-flex align-items-center justify-content-center flex-column gap-4 border border-black pt-4 pb-4">
                  <h3>👑 Premium Plan</h3>
                  <Link
                    href="/register/premium-weekly-25"
                    className="package-card d-flex justify-content-center align-items-center flex-column"
                  >
                    <span className="calendar-text-wrapper">
                      <Image src={blankCalendar.src} width="150" height="120" alt="seven days" />
                      <span className="text pl-2 pr-2 fw-9"> 1 WEEK </span>
                    </span>
                    <strong className="mt-3 cursor-pointer btn btn-dark">$79.99 Every Week</strong>
                  </Link>
                  <Link
                    href="/register/premium-monthly-25"
                    className="package-card d-flex justify-content-center align-items-center flex-column"
                  >
                    <span className="calendar-text-wrapper">
                      <Image src={blankCalendar.src} width="150" height="120" alt="seven days" />
                      <span className="text pl-2 pr-2 fw-9"> 1 MONTH </span>
                    </span>
                    <strong className="mt-3 cursor-pointer btn btn-dark">$249.99 Every Month</strong>
                  </Link>
                  <Link
                    href="/register/premium-annual-25"
                    className="package-card d-flex justify-content-center align-items-center flex-column"
                  >
                    <span className="calendar-text-wrapper">
                      <Image src={blankCalendar.src} width="150" height="120" alt="seven days" />
                      <span className="text pl-2 pr-2"> 1 YEAR </span>
                    </span>
                    <strong className="mt-3 cursor-pointer btn btn-dark">$1,499.99 Every Year</strong>
                    <div className="text-orange">Save 50%</div>
                  </Link>
                  <div className="text-left p-2 w-100">
                    <h4 className="text-center">What do I get?</h4>

                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> NBA Live Scorecenter</span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> NBA Player Prop Data </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> NBA Betting Writeups </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> ShotQuality Standings </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> ShotQuality NBA Trends </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> Daily Predicted ShotQuality Scores </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> Matchup Simulator </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> Individual Player Data </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> ALL NCAA Live Games </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center">
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", minWidth: "2rem", color: "#719a3a" }} />{" "}
                      <span> ShotQuality Game Results Past 7 Days </span>
                    </p>
                    <p className="text-black d-flex gap-1 align-items-center" style={{ maxWidth: "20rem" }}>
                      <BiSolidCheckboxChecked style={{ fontSize: "2rem", color: "#719a3a", minWidth: "2rem" }} />
                      <a
                        href="https://discord.com/invite/shotquality"
                        className="text-black is-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image src={DiscordLogo.src} height={15} width={20} alt="green tick" /> Members have early
                        access to Live Picks and Members only content in Discord. ⏰
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="d-flex flex-wrap justify-content-center gap-2">
              <Link
                href="/register/day-pass"
                className="package-card d-flex justify-content-center align-items-center flex-column"
              >
                <span className="calendar-text-wrapper">
                  <Image src={blankCalendar.src} width="150" height="120" alt="seven days" />
                  <span className="text pl-2 pr-2"> Day Pass </span>
                </span>
                <strong className="mt-3 cursor-pointer btn btn-dark">$9.99</strong>
              </Link>
              <Link
                href="/register/weekly"
                className="package-card d-flex justify-content-center align-items-center flex-column"
              >
                <Image src={Day7.src} width="150" height="120" alt="seven days" />
                <strong className="mt-3 cursor-pointer btn btn-dark" id="seven-days">
                  $19.95 EVERY WEEK
                </strong>
              </Link>
              <Link
                href="/register/monthly"
                className="package-card d-flex justify-content-center align-items-center flex-column"
              >
                <Image src={OneMonth.src} width="150" height="120" alt="seven days" />
                <strong className="mt-3 cursor-pointer btn btn-dark">$79.95 EVERY MONTH</strong>
              </Link>
              <Link
                href="/register/yearly"
                className="package-card d-flex justify-content-center align-items-center flex-column"
              >
                <Image src={OneYear.src} width="150" height="120" alt="seven days" />
                <strong className="mt-3 cursor-pointer btn btn-dark">$599.95 EVERY YEAR</strong>
              </Link>
            </div> */}
            {/* <div className="text-center mt-4">
              <p style={{ fontWeight: "bold" }}>
                Get <Link href={"/welcome-premium"}>Premium Access</Link> to all live games, all predicted scores, and
                historical ShotQuality scores.
              </p>
            </div> */}

            {/* <div className="mt-5 row d-flex justify-content-center align-items-center flex-column">
              <div className="col-md-2"></div>
              <div className="col-md-6 mt-3 d-flex justify-content-start align-items-start flex-column ">
                <div className="d-flex align-items-center" style={{ gap: "1.8rem" }}>
                  <Image src={GreenTick.src} height={30} width={30} alt="green tick" />
                  <h5 className="m-0">
                    Live scores for selected games showing live regression stats to power your live picks.
                  </h5>
                </div>
              </div>
              <div className="col-md-6 mt-3 d-flex justify-content-start align-items-start flex-column ">
                <div className="d-flex align-items-center" style={{ gap: "1.8rem" }}>
                  <Image src={GreenTick.src} height={30} width={30} alt="green tick" />
                  <h5 className="m-0">
                    The world's largest database of NCAA player location data powering the sharpest predicted scores.
                  </h5>
                </div>
              </div>
              <div className="col-md-6 mt-3 d-flex justify-content-start align-items-start flex-column ">
                <div className="d-flex align-items-center" style={{ gap: "1.8rem" }}>
                  <Image src={GreenTick.src} height={30} width={30} alt="green tick" />
                  <h5 className="m-0">
                    Access to the matchup simulator, betting analysis, regression statistics, and more.
                  </h5>
                </div>
              </div>
              <div className="col-md-6 mt-3 d-flex justify-content-start align-items-start flex-column ">
                <div className="d-flex align-items-center" style={{ gap: "1.8rem" }}>
                  <Image src={GreenTick.src} height={30} width={30} alt="green tick" />
                  <h5 className="m-0">
                    <a href="https://discord.com/invite/shotquality" target="_blank" rel="noopener noreferrer">
                      <Image src={DiscordLogo.src} height={20} width={25} alt="green tick" /> Members have early access
                      to live picks and members only content in Discord. ⏰
                    </a>
                  </h5>
                </div>
              </div>
              <div className="col-md-6 mt-3 d-flex justify-content-start align-items-start flex-column ">
                <div className="d-flex align-items-center" style={{ gap: "1.8rem" }}>
                  <Image src={GreenTick.src} height={30} width={30} alt="green tick" />
                  <h5 className="m-0">Cancel Anytime</h5>
                </div>
              </div>
              <div className="col-md-2"></div>
            </div> */}
          </div>
          {/**<Row className="new-container" style={{ background: "#f3f4f6" }}>
            <Container className="d-flex justify-content-center">
              <div className="danKatz-container">
                <img src={Utils.getAsset("big_cat.png").default?.src} className="profile-image" />

                <div className="description-container">
                  <div className="fio">
                    <div className="fio-container">
                      <p>Dan Katz</p>
                      <p>@BarstoolBigCat</p>
                    </div>
                    <img src={Utils.getAsset("Group.png").default?.src} className="image-que" />
                  </div>
                  <p className="description">
                    Makes it easy to help you find value on the board, and you know I love the board.
                  </p>
                </div>
              </div>
  </Container>
          </Row>**/}

          <div className="container text-center">
            <WelcomeScoreCards />
            {/* <Image
              src={nbaLiveBanner}
              style={{
                height: "max-content",
                marginTop: "1rem",
                border: "1px solid #08080833",
                padding: "1rem",
                borderRadius: "1rem",
              }}
              width={625}
              height={529}
              priority={true}
              alt="Comprehensive NBA Basketball Picks and Predictions Chart with Analytics and Trend Lines"
            /> */}
          </div>
          {/**
          <div className="mt-5 container">
            <h3 className="text-center">Picks and Predictions Powered by the Best data in Basketball</h3>
            <p className="mt-3 text-center" style={{ fontWeight: "bold" }}>
              ShotQuality's player location data powers predictive shot models which deliver the most accurate
              predictions in basketball for NCAAB games. Our matchup, team, and player analysis goes beyond the box
              score to help you win more.
            </p>
          </div>
          <div className="container mt-5">
            <LineValueStats league={"ncaa"} />
          </div>
          */}

          <Testimony />

          <section className="container accordion-container ">
            <div className="mt-5 box col-md-12 text-center titles-container align-items-center justify-content-center mb-4">
              <h2>Frequently Asked Questions</h2>
            </div>
            <div className="row mb-5" itemScope itemType="https://schema.org/FAQPage">
              {accordionData.map(({ name, acceptedAnswer, id }) => {
                return (
                  <div key={id} className="col-md-6 faq-item">
                    <Accordion title={name} content={acceptedAnswer.text} id={id} key={name} />
                  </div>
                );
              })}
            </div>
          </section>
        </div>
      </MainLayout>
    </>
  );
};

export default Pricing;

export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  if (Utils.isTrader(user)) {
    return {
      redirect: {
        destination: "/trader-dashboard",
        permanent: false,
      },
    };
  }
  return { props: { user } };
});
